'use client'
import { useState } from 'react'
import { CategoryFaq } from '@/services/dataTypes'
import { HelpCircle } from 'lucide-react'

export default function SidebarFAQs({ faqs }: { faqs: CategoryFaq[] }) {
    const [openIdx, setOpenIdx] = useState<number | null>(null)

    return (
        <div className="rounded-2xl overflow-hidden mt-4" style={{ background: '#FFFFFF', border: '1px solid rgba(92,122,92,0.15)' }}>
            <div className="flex items-center gap-2 px-5 py-4" style={{ background: '#2D3E2D' }}>
                <HelpCircle size={14} style={{ color: '#F5C542' }} />
                <h4 className="text-xs font-black uppercase tracking-wider" style={{ color: '#FAF7F2' }}>FAQs</h4>
            </div>
            <div>
                {faqs.map((faq, i) => (
                    <div key={i} style={{ borderBottom: '1px solid rgba(92,122,92,0.06)' }}>
                        <button
                            onClick={() => setOpenIdx(openIdx === i ? null : i)}
                            className="w-full flex items-center justify-between px-5 py-3 text-left bg-transparent cursor-pointer"
                        >
                            <span className="text-xs font-semibold pr-2" style={{ color: 'rgba(45,62,45,0.8)' }}>{faq.question}</span>
                            <svg className={`w-3.5 h-3.5 flex-shrink-0 transition-transform duration-200 ${openIdx === i ? 'rotate-180' : ''}`}
                                fill="none" viewBox="0 0 24 24" stroke="currentColor" style={{ color: '#F5C542' }}>
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                            </svg>
                        </button>
                        <div className={`grid transition-[grid-template-rows] duration-300 ${openIdx === i ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
                            <div className="overflow-hidden">
                                <div className="px-5 pb-3 text-xs leading-relaxed" style={{ color: 'rgba(45,62,45,0.6)' }}
                                    dangerouslySetInnerHTML={{ __html: faq.answer }} />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
